import MainLayout from "./components/MainLayout";

export default function App() {
  return <MainLayout />;
}
